import { VisitBroadcastId } from "../../shared/schema/schema";
import { createQueryKeys } from "../../shared/utils/create-query-keys";

export const visitBroadcastKeys = createQueryKeys("visit_broadcast", {
  get: (id: VisitBroadcastId) => id,
  list: null,
  search: (searchTerm: string) => ({ searchTerm }),
});
